import {
  getUserPlatformRelationsByPlatform,
  getUserPlatformRelationsByUser,
  setRelations,
  setRoleRelationAll,
  setRoleRelations,
} from '@/services/auth/AuthController';
import { getCompanyListToTable } from '@/services/company/CompanyController';
import { getProjectListWithCompany } from '@/services/project/ProjectController';
import { getRoleList } from '@/services/role/RoleController';
import { getAdminList } from '@/services/user/UserController';
import { useRequest, useSetState } from 'ahooks';
import { debounce } from 'lodash-es';
import { useEffect, useState } from 'react';
interface State {
  width: number;
  height: number;
  pageSize: number;
  column?: number;
  itemStyle: {
    width: number | string;
  };
  [key: string]: any;
}

export default function AuthModel() {
  const [loading, setLoading] = useState(false);

  const [pageSize, setPageSize] = useState(10);
  const [state, setState] = useSetState<State>({
    width: 0,
    height: 0,
    pageSize: 10,
    itemStyle: {
      width: 0,
    },
  });
  /** 权限页面共享, 根据不同的路由获取不同的params参数 */
  const AuthPageParams = new Map([
    ['/main/permission/auth', { level: '1', type: 'company' }],
    ['/main/permission/auth-to-user', { level: '1', type: 'user', platform_id: '1' }], // user页面时需要查询授权平台角色
  ]);

  /** 获取拥有相应绑定关系的用户列表**/
  const getRelationUserListReq = useRequest(getUserPlatformRelationsByUser, {
    manual: true,
  });

  /**获取用户列表*/
  const getAdminListReq = useRequest(getAdminList, {
    manual: true,
  });

  /** 绑定用户和平台实例 ( 公司/项目 )*/
  const setRelationsApi = useRequest(setRelations, {
    manual: true,
  });
  /** 将绑定关系与角色关联 (用户与 [公司/项目]的绑定关系) */
  const setRoleRelationsReq = useRequest(setRoleRelations, {
    manual: true,
  });
  const setRoleRelationAllReq = useRequest(setRoleRelationAll, {
    manual: true,
  });

  /** 获取和平台实体有绑定关系的用户id列表 ( 不分页 ) */
  const getAdminIds = useRequest(getUserPlatformRelationsByUser, {
    manual: true,
  });

  /** 获取项目列表 */
  const getProjectListWithCompanyReq = useRequest(getProjectListWithCompany, {
    manual: true,
  });

  /** 获取与用户关联的项目列表 或者 对应的所有 id list*/
  const getUserPlatformRelationsByPlatformReq = useRequest(getUserPlatformRelationsByPlatform, {
    manual: true,
  });

  /** 获取角色列表 */
  const getRoleListReq = useRequest(getRoleList, {
    manual: true,
  });

  /** 获取公司列表 */
  const getCompanyListToTableReq = useRequest(getCompanyListToTable, {
    manual: true,
  });

  /**绑定角色**/
  const onSetRoleId = (data: { relation_id: number; roles: number[]; type: 'user' | 'platform' }) => {
    setLoading(true);
    return setRoleRelationsReq.runAsync(data);
  };

  /**批量绑定角色**/
  const onSetRoleIdAll = (data: {
    project_id?: number;
    admin_id?: number;
    platform_id?: number;
    platform_entity_id?: number;
    relation_id: number;
  }) => {
    // 开启loading
    setLoading(true);
    return setRoleRelationAllReq.runAsync(data);
  };

  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [
    getRelationUserListReq,
    getAdminListReq,
    setRelationsApi,
    setRoleRelationsReq,
    setRoleRelationAllReq,
    getAdminIds,
    getProjectListWithCompanyReq,
    getUserPlatformRelationsByPlatformReq,
    getRoleListReq,
    getCompanyListToTableReq,
  ];

  // 此处监听依赖无法通过展开effectLoadingList方式简化,因为展开会导致每次都会重新渲染
  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 0);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [
    getRelationUserListReq,
    getAdminListReq,
    setRelationsApi,
    setRoleRelationsReq,
    setRoleRelationAllReq,
    getAdminIds,
    getProjectListWithCompanyReq,
    getUserPlatformRelationsByPlatformReq,
    getRoleListReq,
    getCompanyListToTableReq,
  ]);

  return {
    AuthPageParams,
    setRelationsApi,
    setRoleRelationsReq,
    setRoleRelationAllReq,
    getAdminIds,
    getRelationUserListReq,
    getAdminListReq,
    getProjectListWithCompanyReq,
    getUserPlatformRelationsByPlatformReq,
    getRoleListReq,
    getCompanyListToTableReq,
    onSetRoleId,
    onSetRoleIdAll,
    setLoading,
    loading,
    pageSize,
    setPageSize,
    state,
    setState,
  };
}
